import React, { Fragment } from "react";
import { FaLock } from "react-icons/fa6";
import { BiWorld } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";

export default function Groups({ groupSearchData, handleJoinGroup: handleJoinGroupProp, handleCancelJoinRequest, loading, SearchItem }) {
    const navigate = useNavigate();

    const filteredGroups = groupSearchData && SearchItem
        ? groupSearchData.filter((data) =>
            data.group_name && data.group_name.toLowerCase().includes(SearchItem.toLowerCase())
        )
        : groupSearchData;

    // Update handleJoinGroup to handle private/public logic
    const handleJoinGroup = async (groupId, groupType) => {
        const response = await handleJoinGroupProp(groupId); // handleJoinGroupProp is the prop from parent
        if (groupType === "private") {
            // For private, just send request, do not navigate
            return;
        } else if (groupType === "public") {
            // For public, after join, navigate to group
            navigate(`/group/${groupId}`);
        }
    };

    return (
        <Fragment>
            {loading ? (
                <div className="flex justify-center items-center h-[50vh]">
                    <ClipLoader size={30} color={"#616163"} />
                </div>
            ) : (
                <div className="px-2">
                    {filteredGroups && filteredGroups.length > 0 ? (
                        filteredGroups.map((data) => (
                            <div 
                                key={data.id} 
                                className="flex items-start gap-2 py-2 border-b-2 border-gray-200 dark:border-gray-800"
                            >
                                <img
                                    alt={data.group_name}
                                    src={data.group_profile_picture}
                                    onClick={() => navigate(`/group/${data.id}`)}
                                    className="w-12 h-12 rounded-md object-cover border border-gray-200 dark:border-gray-800 cursor-pointer"
                                />
                                <div className="">
                                    <p
                                        onClick={() => navigate(`/group/${data.id}`)}
                                        className="font-semibold text-[11px] text-black dark:text-white line-clamp-1 cursor-pointer w-fit"
                                    >
                                        {data.group_name}
                                    </p>
                                    <p
                                        onClick={() => navigate(`/group/${data.id}`)}
                                        className="font-semibold text-[11px] text-black dark:text-white line-clamp-1 cursor-pointer"
                                    >
                                        {data.description}
                                    </p>
                                    <p className="font-medium text-[10px] text-gray-500 dark:text-gray-700">
                                        {data?.member_count} members
                                    </p>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="flex justify-center items-center h-[25vh]">
                            <p className="text-[12px] text-gray-500">
                                No group found
                            </p>
                        </div>
                    )}
                </div>
            )}
        </Fragment>
    );
}
